import { z } from 'zod'

/**
 * A File (docs/areas/files.md): a file's metadata or, with `folder`, a folder.
 * The bytes live in the S3 bucket under `key` (opaque, `o/<uuid>`, never the
 * name); `thumb_key` is a small picture the uploading device made; `sha256`
 * lets a second upload of the same bytes reuse the first object. Mirrors
 * internal/kinds/file.
 */
export const KEY_RE = /^o\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/

export const fileSpec = z
  .object({
    name: z.string().min(1).max(255),
    parent: z
      .string()
      .regex(/^[0-9a-f-]{36}$/)
      .optional(),
    folder: z.boolean().optional(),
    size: z.number().int().min(0).max(5_497_558_138_880).optional(),
    content_type: z.string().max(255).optional(),
    key: z.string().regex(KEY_RE).optional(),
    thumb_key: z.string().regex(KEY_RE).optional(),
    sha256: z
      .string()
      .regex(/^[0-9a-f]{64}$/)
      .optional(),
    starred: z.boolean().optional(),
  })
  .strict()
export type FileSpec = z.infer<typeof fileSpec>

export const fileStatus = z.object({
  state: z.enum(['uploading', 'ready']).optional(),
  uploaded_at: z.string().optional(),
  purged_at: z.string().optional(),
})
export type FileStatus = z.infer<typeof fileStatus>
